import xmlFelGen from  './xmlFelGen'
import xmlFelPeq from './xmlFelPeq'

async function generateXML(emisor,cliente,productos,documento) {
    // const felhead = await headFel(emisor,cliente)
    // const felbody = await bodyFel(productos)
    // const felfooter = await footerFel(documento)

    let FelGenerado = ''
    if(emisor.codregimen=="GEN"){

    FelGenerado = xmlFelGen(emisor,cliente,productos,documento)

    }else{
        
    FelGenerado = xmlFelPeq(emisor,cliente,productos,documento)
    
    }
return  FelGenerado
}

export default generateXML